function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fill: "#FFFFFF",
  fillRule: "evenodd",
  d: "M55.213 23.9h-5.46L42.106 44.84h5.461L55.213 23.9zM34.47 68.584c-.342 0-.68 0-1.015-.008l7-19.224h9.641c1.697 0 3.554-1.3 4.13-2.883l7.607-20.847c1.233-3.403-.72-6.2-4.362-6.2H44.104l-11.225 30.78h-.01l-6.364 17.456C11.418 64.076.183 50.532.183 34.368.183 18.672 10.775 5.443 25.21 1.41l-6.557 18.012-10.913 29.93H15l9.276-25.432h5.469l-9.284 25.432h7.263l8.649-23.73c1.233-3.403-.712-6.2-4.348-6.2h-6.11L32.931.186c.51-.022 1.025-.038 1.54-.038 18.931 0 34.28 15.322 34.28 34.22 0 18.903-15.349 34.217-34.28 34.217z"
});

var SvgFill29 = function SvgFill29(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 69 69",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgFill29, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/fill-29.2654fec7.svg";
export { ForwardRef as ReactComponent };